export default __webpack_public_path__ + "static/media/BasicImage.9b1e961c.png";